import { FormField } from '@portals/api';

export type Form = {
	name: string;
	form_fields: Array<FormField>;
};
